module.exports = __webpack_public_path__ + "static/media/user-icon-blue.cc19808d.png";